import styled from 'styled-components';

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 18px;
`;

export const LogoContainer = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 0 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 2 0 0;
`;
